export enum Tabs {
  Tokens = 'tokens',
  Usd = 'usd',
}
